import script from "./career.vue?vue&type=script&setup=true&lang=js"
export * from "./career.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__